import React, { useState } from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import { apiResolveStrWeak } from "../../../../apiBindings";
import LinkComponent from "../../LinkComponent";
import Button from "../../NewForms/Button";
import SmallShapeContainer from "../../SmallShapeContainer";
import HeadlineItem from "../ContentElement/HeadlineItem";

const Container = styled.div`
    ${({ theme }) => css`
        ${theme.paddings.containerOuter.right}
        ${theme.paddings.containerOuter.left}
    `}
`;

const Grid = styled.div`
    display: grid;
    column-gap: 20px;
    row-gap: 50px;
    margin-top: 30px;
    grid-template-columns: repeat(1, 1fr);
    justify-content: space-between;
    ${({ theme }) => theme.breakpoints.from.small.css`
       grid-template-columns: repeat(2, 1fr);
       justify-content: space-around;
    `}
    ${({ theme }) => theme.breakpoints.from.normal.css`
       grid-template-columns: repeat(4, 1fr);
       justify-content: space-between;
    `}
`;

const List = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: space-between;
    height: 100%;
    margin-top: 30px;
    margin-bottom: 30px;
    font-size: 0.9rem;
    font-weight: 600;
`;

const ItemHeadline = styled.div`
    display: flex;
    flex-direction: column;
`;
const Item = styled.p``;

const Text = styled.p`
    font-size: 1.4rem;
    color: ${({ theme }) => theme.colors.blue.toString()};
`;

const ActionRow = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 50px;
    ${({ theme }) => theme.breakpoints.from.medium.css`
        display: none;
    `}
`;

const ShapeContainer = styled(SmallShapeContainer)`
    width: 260px;
    margin: 0 auto;
`;

const SmallLabel = styled.div`
    margin-top: 5px;
    font-size: 10px;
`;

const Value = styled.div`
    font-weight: normal;
`;

const regex = /^https?:/;

const BusinessCardGrid = ({ businessCards, name, headlineNumber, text }) => {
    const theme = useTheme();

    const textContainerCss = css`
        min-height: 120px;
        padding-left: 30px;
    `;

    const mobileHidden = css`
        display: none;
        ${theme.breakpoints.from.medium.css`
             display: flex;
        `}
    `;

    const [isOpen, setIsOpen] = useState(false);

    return (
        <Container>
            {name && (
                <HeadlineItem headline={headlineNumber} color="red">
                    {name}
                </HeadlineItem>
            )}
            {text && <Text>{text}</Text>}
            <Grid>
                {businessCards.map((item, index) => (
                    <ShapeContainer
                        key={index}
                        css={index >= 3 && !isOpen && mobileHidden}
                    >
                        <SmallShapeContainer.TextContainer
                            css={textContainerCss}
                        >
                            <List>
                                <ItemHeadline>
                                    <span
                                        css={css`
                                            font-size: 1rem;
                                            font-weight: 900;
                                        `}
                                    >
                                        {item.name}
                                    </span>
                                    <span
                                        css={css`
                                            font-weight: normal;
                                        `}
                                    >
                                        {item.position}
                                    </span>
                                </ItemHeadline>
                                <Item>
                                    {item.phone && (
                                        <>
                                            <SmallLabel>Tel:</SmallLabel>
                                            <Value>{item.phone}</Value>
                                        </>
                                    )}
                                    {item.mobile && (
                                        <>
                                            <SmallLabel>Mobil:</SmallLabel>
                                            <Value>{item.mobile}</Value>
                                        </>
                                    )}
                                    <SmallLabel>E-Mail:</SmallLabel>
                                    <Value>{item.mail}</Value>
                                </Item>
                            </List>
                            <LinkComponent
                                link={{
                                    href: regex.test(item.link.href)
                                        ? item.link.href
                                        : apiResolveStrWeak(
                                              item.link.href || "/"
                                          ),
                                    text: item.link.text,
                                }}
                                icon="arrow-right"
                            />
                        </SmallShapeContainer.TextContainer>
                    </ShapeContainer>
                ))}
            </Grid>
            <ActionRow>
                <Button onClick={() => setIsOpen(!isOpen)}>
                    {isOpen ? "Weniger Anzeigen" : "Alle Anzeigen"}
                </Button>
            </ActionRow>
        </Container>
    );
};

export default BusinessCardGrid;
